/* GDC voor Bedrijven — contact-popup controller
 *
 * Vervangt de eerdere inline <script> blocks in gdc-hero en gdc-process.
 * Werkt via data-attributes (geen bindings per section nodig):
 *   data-gdc-popup-open="<popup_id>"   - knop die popup opent
 *   data-gdc-popup-close="<popup_id>"  - X-knop in popup
 *   data-gdc-popup-scrim="<popup_id>"  - backdrop (klik = sluit)
 *   id="<popup_id>"                    - dialog zelf
 *   data-gdc-popup-success             - aanwezig na success → auto-open
 *
 * Toegevoegd t.o.v. inline versies:
 *   - Focus return naar trigger na sluit (a11y)
 *   - Focus-trap binnen popup (Tab cycle)
 *   - 1 globale ESC-handler i.p.v. 1 per section
 */
(function () {
  if (window.__gdcPopupInit) return;
  window.__gdcPopupInit = true;
  var FOCUSABLE = 'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;
  var activePopup = null;

  function getPopup(id) {
    return document.getElementById(id);
  }
  function getScrim(id) {
    /* Geen CSS.escape: onze popup_id's bevatten alleen [a-zA-Z0-9_-],
       allemaal CSS-safe. Verbeterde compat voor oudere parsers. */
    return document.querySelector('[data-gdc-popup-scrim="' + id + '"]');
  }

  function open(popup, scrim, trigger) {
    lastTrigger = trigger || document.activeElement;
    activePopup = popup;
    if (scrim) {
      scrim.style.display = 'block';
      requestAnimationFrame(function () { scrim.style.opacity = '1'; });
    }
    popup.style.display = 'block';
    requestAnimationFrame(function () {
      popup.style.opacity = '1';
      popup.style.transform = 'translate(-50%,-50%)';
    });
    document.documentElement.style.overflow = 'hidden';
    // Focus eerste focusable element binnen popup (na render-cyclus)
    setTimeout(function () {
      var focusables = popup.querySelectorAll(FOCUSABLE);
      if (focusables.length) focusables[0].focus();
    }, 50);
  }

  function close(popup, scrim) {
    popup.style.opacity = '0';
    popup.style.transform = 'translate(-50%,-46%)';
    if (scrim) scrim.style.opacity = '0';
    setTimeout(function () {
      popup.style.display = 'none';
      if (scrim) scrim.style.display = 'none';
      document.documentElement.style.overflow = '';
      // Focus terug naar de trigger-button (a11y)
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
      activePopup = null;
      lastTrigger = null;
    }, 250);
  }

  // 1a. Direct-binding op trigger elements als fallback (in geval document
  //     delegatie ergens gestopt wordt door een andere handler higher up)
  function bindDirect() {
    var opens = document.querySelectorAll('[data-gdc-popup-open]');
    opens.forEach(function (el) {
      if (el.__gdcBound) return;
      el.__gdcBound = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = el.getAttribute('data-gdc-popup-open');
        var popup = getPopup(id);
        var scrim = getScrim(id);
        if (popup) open(popup, scrim, el);
      });
    });
    document.querySelectorAll('[data-gdc-popup-close]').forEach(function (el) {
      if (el.__gdcBound) return;
      el.__gdcBound = true;
      el.addEventListener('click', function () {
        var id = el.getAttribute('data-gdc-popup-close');
        var popup = getPopup(id);
        var scrim = getScrim(id);
        if (popup) close(popup, scrim);
      });
    });
    document.querySelectorAll('[data-gdc-popup-scrim]').forEach(function (el) {
      if (el.__gdcBound) return;
      el.__gdcBound = true;
      el.addEventListener('click', function (e) {
        if (e.target !== el) return;
        var id = el.getAttribute('data-gdc-popup-scrim');
        var popup = getPopup(id);
        if (popup) close(popup, el);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDirect);
  } else {
    bindDirect();
  }

  // 1b. Document-level fallback voor dynamisch toegevoegde elementen
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-gdc-popup-open]');
    if (openBtn && !openBtn.__gdcBound) {
      e.preventDefault();
      var id = openBtn.getAttribute('data-gdc-popup-open');
      var popup = getPopup(id);
      var scrim = getScrim(id);
      if (popup) open(popup, scrim, openBtn);
    }
  });

  // 2. Globale ESC sluit actieve popup
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activePopup) {
      var id = activePopup.id;
      close(activePopup, getScrim(id));
      return;
    }
    // Focus-trap: Tab cycle binnen actieve popup
    if (e.key === 'Tab' && activePopup) {
      var focusables = activePopup.querySelectorAll(FOCUSABLE);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // 3. Auto-open na success post (form ge-submit, popup heeft data-gdc-popup-success)
  document.querySelectorAll('[data-gdc-popup-success]').forEach(function (successEl) {
    var popup = successEl.closest('[role="dialog"][id]');
    if (popup) {
      var scrim = getScrim(popup.id);
      // Korte delay zodat de page eerst rendert, dan popup opent
      setTimeout(function () { open(popup, scrim, null); }, 100);
    }
  });

  // 4. Loading-spinner op submit: form doet full-page POST → tussen click en
  // success-render zat een lege wachtperiode. Label naar 'Versturen...' +
  // spinner zichtbaar + button disabled (geen double-submit).
  document.querySelectorAll('form.gdc-popup-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.gdc-popup-form__submit');
      if (!btn) return;
      var label = btn.querySelector('.gdc-popup-form__submit-label');
      if (label) label.textContent = 'Versturen...';
      btn.classList.add('is-loading');
      btn.disabled = true;
      // aria-busy zodat screenreaders status doorgeven
      btn.setAttribute('aria-busy', 'true');
    });
  });
})();
